
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saa/category",
      function () {
        return require("private-next-pages/saa/category.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saa/category"])
      });
    }
  